<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import MlssTable from './MlssTable';

export default {
  page: {
    title: 'MLS',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, MlssTable },
  data() {
    return {
      title: 'MLS',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'MLS', active: true, },
      ],
      
      loading: true,
    }
  },
  created() {

  },
  methods: {
    
  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id" :key="$route.fullPath"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
        <div class="col-12">
          <div class="card-box p-0 position-relative">
            <MlssTable ref="MlssTable" @loadchange="(e) => {loading = e;}"></MlssTable>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
